import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const NavigationUtils = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const urlParams = useParams();

    const urlUsername = urlParams.username?.replace(/^@/, "");
    const locationPathName = location.pathname;
    const locationSearch = location.search;

    const navigateToThread = (twutId, options = undefined) => {
        navigateToLocation(`/twuts/${twutId}`, options);
    };

    const navigateBack = (distance = -1, options = undefined) => {
        navigate(distance, options);
    };

    const navigateHome = (options = undefined) => {
        navigateToLocation('/', options);
    };

    const navigateToLocation = (location, options = undefined) => {
        navigate(location, options);
    };

    return {
        urlParams,
        urlUsername,
        locationPathName,
        locationSearch,
        navigateToThread,
        navigateBack,
        navigateHome,
        navigateToLocation,
    };
};
